import { isDefined } from '@/composables/utils'
import type { ITableHeader } from '@/interfaces/ITableHeader'
import { useAppStore } from '@/stores/ui/AppStore'
import { type Composer } from 'vue-i18n'
import type { DatasetRecord } from '../DatasetRecord'
import type { TableRecord } from '../TableRecord'

export const getTableHeaders = (
  i18n: Composer<{}, {}, {}, string, never, string>
): Array<ITableHeader> => {
  const appStore = useAppStore()
  return [
    {
      title: i18n.t('fields.datasets.name'),
      key: 'name',
      align: 'start',
      nowrap: true,
      headerProps: { searchField: true }
    },
    {
      title: i18n.t('fields.datasets.description'),
      key: 'description',
      align: 'start',
      nowrap: false,
      headerProps: { searchField: true },
      value: (item: TableRecord) =>
        isDefined(item.description) ? item.description : i18n.t('labels.dash')
    },
    {
      title: i18n.t('fields.datasets.timeZone'),
      key: 'timeZone',
      align: 'start',
      nowrap: false,
      headerProps: { searchField: true },
      value: (item: TableRecord) => item.timeZone.replace('_', ' ')
    },
    {
      title: i18n.t('fields.datasets.isEnabled'),
      key: 'isEnabled',
      value: (item: DatasetRecord) =>
        `${item.isEnabled ? i18n.t('labels.yes') : i18n.t('labels.no')}`,
      align: 'start',
      sortable: true,
      nowrap: true
    },
    {
      title: i18n.t('fields.datasets.type'),
      key: 'isSandbox',
      value: (item: DatasetRecord) =>
        `${item.isSandbox ? i18n.t('labels.sandbox') : i18n.t('labels.production')}`,
      align: 'start',
      sortable: true,
      nowrap: true
    },
    {
      title: i18n.t('fields.actions'),
      key: 'actions',
      align: 'start',
      nowrap: true,
      sortable: false,
      headerProps: { hidden: !appStore.isProgramAdmin }
    }
  ]
}
